var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasCoordinates)?_c('iframe',{staticClass:"map-preview",attrs:{"src":_vm.mapSrc,"frameborder":"0"}}):_c('div',{staticClass:"no-map-preview"},[_c('v-icon',{attrs:{"large":""}},[_vm._v(" mdi-map-marker-off ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }